










































































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  reactive
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import Snackbar from '../../molecules/Snackbar.vue'
import FormHeader from '../../molecules/FormHeader.vue'
import DialogUnlikeUser from './DialogUnlikeUser.vue'
import DialogLikeUser from './DialogLikeUser.vue'
import CompanyErrorDialog from '../../../views/CompanyInformation/CompanyErrorDialog.vue'

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const customerId = window.location.pathname.split('/')[4]
    const jobId = window.location.pathname.split('/')[6]  
    const commonId = window.location.pathname.split('/')[8]  
    const userDetail = company.getUserDetailInfor
    const getUserSkill = company.getUserSkill
    const deleteFavoriteUser = () => {
      displayui.openDialogUnlikeUser()
    }
    const addFavoriteUser = async () => {
      displayui.openDialogLikeUser()
    }

    const execApplication = async (application_code: string) => {
      const result = await company.execApplication(customerId, jobId, commonId, application_code) as any;
      if(result && result.data){
        displayui.openDialogCompanyError();
      }else{
        getUserSkill(jobId,customerId)
        userDetail(jobId,customerId)
      }
    }
    const getFavoriteUser = company.getFavoriteUser

    onMounted(async() => {
      getUserSkill(jobId,customerId)
      userDetail(jobId,customerId)
      company.getIsavoriteUser(customerId)
    });

    const userInfor = computed(() => company.userDetailInformation);
    const userInforList = computed(() => company.userDetailInformation.userInforList);

    const isTimeLimit = computed(() => {
      var now_date = new Date()
      var time_limit = new Date(company.userDetailInformation.work_start)
      var isLimit = (time_limit.getTime() <= now_date.getTime() || company.userDetailInformation.applicationStatus != '応募');
      return isLimit;
    });
    
    return {
      userInfor,
      userInforList,
      customerId,
      deleteFavoriteUser,
      addFavoriteUser,
      company,
      isTimeLimit,
      execApplication
    };
  },

  components : {
    Snackbar,
    FormHeader,
    DialogUnlikeUser,
    DialogLikeUser,
    CompanyErrorDialog
  },
})
